import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import DashBoard from '../views/DashBoard.vue'
import WebAppPlans from '../views/WebAppPlansV2.vue'
import Micro from '../components/Micro/Index.vue'
const MicroTopUp = () => import('../components/Micro/TopUpTokensIframe.vue')
const DashBoardContnet = () => import('../components/DashBoard/Content.vue')
const DashBoardDetail = () => import('../components/DashBoard/TeamDetail.vue')
// const WhiteList = () => import('../components/DashBoard/WhiteList.vue')
const GoWhitelist = () => import('../components/DashBoard/GoWhitelist.vue')
const SkuList = () => import('../components/DashBoard/SkuList/index.vue')
const TokenUsage = () => import('../components/DashBoard/TokenUsage/Index.vue')
const tokenManage = () => import('../components/DashBoard/TokenManagement/Index.vue')
const Subscriptions = () => import('../components/DashBoard/Subscriptions/Index.vue')
const TokenCheckGroups = () => import('../components/DashBoard/TokenCheckGroups/Index.vue')
Vue.use(VueRouter)

const homeRoute = {
  path: '/',
  name: 'Home',
  component: Home,
  meta: {
    title: 'Home'
  }
}

const webAppRoute = {
  path: '/',
  name: 'WebAppPlans',
  component: WebAppPlans,
  meta: {
    title: 'Web App'
  }
}

const microAppRoute = {
  path: '/microapp',
  name: 'MicroAppPlans',
  component: Micro,
  meta: {
    title: 'Micro App'
  }
}

const microAppTopUpRoute = {
  path: '/microapp/topup',
  name: 'MicroAppTopUp',
  component: MicroTopUp,
  meta: {
    title: 'Top up tokens'
  }
}

const dashboardChildren = [
  {
    path: '',
    name: 'DashBoardContnet',
    component: DashBoardContnet,
    meta: {
      title: 'Dashboard'
    }
  },
  {
    path: 'team/:id',
    name: 'DashBoardDetail',
    component: DashBoardDetail,
    meta: {
      title: 'Team Detail'
    }
  },
  {
    path: 'tokenUsage',
    name: 'TokenUsage',
    component: TokenUsage,
    meta: {
      title: 'Token Usage'
    }
  },
  {
    path: 'sku',
    name: 'SKU',
    component: SkuList,
    meta: {
      title: 'SKU List'
    }
  },
  {
    path: 'whitelist',
    name: 'WhiteList',
    component: tokenManage,
    meta: {
      title: 'Whitelist'
    }
  },
  {
    path: 'gowhitelist',
    name: 'GoWhitelist',
    component: GoWhitelist,
    meta: {
      title: 'Go Whitelist'
    }
  },
  {
    path: 'tokenManage',
    name: 'TokenManage',
    component: tokenManage,
    meta: {
      title: 'Token Management'
    }
  },
  {
    path: 'subscriptions',
    name: 'Subscriptions',
    component: Subscriptions,
    meta: {
      title: 'Subscriptions'
    }
  },
  {
    path: 'tokenCheckGroups',
    name: 'TokenCheckGroups',
    component: TokenCheckGroups,
    meta: {
      title: 'Token Check Groups'
    }
  }
]

const dashboardRoute = {
  path: '/dashboard',
  name: 'DashBoard',
  component: DashBoard,
  // redirect: '/',
  children: dashboardChildren,
  meta: {
    title: 'Dashboard'
  }
}

let routes = []
function controlLoading (flag) {
  const loading = document.querySelector('#global-loading')
  if (loading) {
    loading.style.display = flag ? 'block' : 'none'
  }
}

if (window.self !== window.top) {
  routes = [homeRoute, microAppRoute, microAppTopUpRoute, { path: '*', redirect: '/' }]
} else if (window.location.hostname.includes('go.tvunetworks.com')) {
  routes = [webAppRoute, { path: '*', redirect: '/' }]
} else {
  webAppRoute.path = '/webapp'
  routes = [dashboardRoute, webAppRoute, microAppRoute, microAppTopUpRoute, { path: '*', redirect: '/dashboard' }]
}

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.afterEach((to, from) => {
  if (to.name) {
    setTimeout(() => {
      controlLoading(false)
    }, 1000)
  }
})

// export function updateRouter (role, env) {
//   if (role === 3) {
//     router.addRoute('DashBoard', {
//       path: 'sku',
//       name: 'SKU',
//       component: SkuList
//     })
//     router.addRoute('DashBoard', {
//       path: 'tokenUsage',
//       name: 'TokenUsage',
//       component: TokenUsage
//     })
//     router.addRoute('DashBoard', {
//       path: 'whitelist',
//       name: 'WhiteList',
//       component: WhiteList
//     })
//     router.addRoute('DashBoard', {
//       path: 'gowhitelist',
//       name: 'GoWhitelist',
//       component: GoWhitelist
//     })
//   } else if (!env.includes('prod')) {
//     router.addRoute('DashBoard', {
//       path: 'tokenUsage',
//       name: 'TokenUsage',
//       component: TokenUsage
//     })
//   }
// }

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}
export default router
